import React from "react";
import styles from "./projectId.module.scss";
import { connect } from "react-redux";
import { ReactComponent as Postulaciones } from "../../../assets/svg/misPostulaciones.svg";
import { motion, AnimatePresence } from "framer-motion";

import ProjectItem from "./projectItem";

const ProjectId = (props) => {
  const isLoaded = props.isLoaded;
  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        initial={{ opacity: 0, y: 200 }}
        animate={{ opacity: 1, y: 0 }}
        className={`${styles.MisPostulaciones} ${
          !isLoaded ? styles.isLoaded : ""
        } ${props.fromPage ? styles.fromPage : ""}`}
      >
        <>
          {props.isQuotation ? (
            <ProjectItem item={props.item} isQuotation />
          ) : (
            <ProjectItem
              item={props.item}
              isAdjudicated={props.isAdjudicated}
            />
          )}
        </>
      </motion.div>
    </AnimatePresence>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoaded: state.general.isLoaded,
    userData: state.general.userData,
  };
};

export default connect(mapStateToProps, { })(ProjectId);
